import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"wi-100",attrs:{"text":""},on:{"click":_vm.logout}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-logout")]),_vm._v("logout")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }